import lightGallery from 'lightgallery';
import lgHash from 'lightgallery/plugins/hash';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

export function initGallery() {
    lightGallery(document.getElementById('gallery'), {
        plugins: [lgHash, lgThumbnail],
        download: false
    });
}